import axios from "@app/Security/AxiosAuthentication";
import htmlParser from "@app/utils/htmlParser";
import ProducerInterface from "@app/Interface/ProducerInterface";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class ProducerHelper {

    static getProducers = async (controller: AbortController, limit?: number, searchTerm?: string): Promise<ProducerInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const params: string[] = [];

        params.push("page=1");

        if (limit) {
            params.push(`limit=${limit}`)
        }

        if (searchTerm) {
            params.push(`search_term=${searchTerm}`);
        }
        
        const query = params.join("&");

        const url = baseUrl + ApiEndpoints.PRODUCER_COLLECTION + "?" + query; 

        return await axios.get(url, {
            withCredentials: true,
            signal: controller.signal
        })
            .then(response => {

                const dataItems: ProducerInterface[] = response.data["hydra:member"];

                const producers = ProducerHelper.getProducersFromResponseData(dataItems);

                return producers;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "getProducers()");
                
                // return an empty set of navItems
                const emptyItems: Array<ProducerInterface> = [];

                return emptyItems;

            });

    }

    /**
     * Transforms/udates data fields, such as htmlDecode on strings 
     * @param dataItems 
     * @returns 
     */
    static getProducersFromResponseData = (dataItems: ProducerInterface[]): ProducerInterface[] => {

        dataItems.forEach(producer => {

            if (typeof producer.alphaName === "string") {
                producer.alphaName = htmlParser.htmlDecode(producer.alphaName);
            }

            if (typeof producer.name1 === "string") {
                producer.name1 = htmlParser.htmlDecode(producer.name1);
            }

            if (typeof producer.name2 === "string") {
                producer.name2 = htmlParser.htmlDecode(producer.name2);
            }

            if (typeof producer.name3 === "string") {
                producer.name3 = htmlParser.htmlDecode(producer.name3);
            }
            
            if (typeof producer.name4 === "string") {
                producer.name4 = htmlParser.htmlDecode(producer.name4);
            }

            if (typeof producer.name5 === "string") {
                producer.name5 = htmlParser.htmlDecode(producer.name5);
            }

            if (typeof producer.state === "string") {
                producer.state = htmlParser.htmlDecode(producer.state);
            }

            if (typeof producer.county === "string") {
                producer.county = htmlParser.htmlDecode(producer.county);
            }

            if (typeof producer.taxLegalName === "string") {
                producer.taxLegalName = htmlParser.htmlDecode(producer.taxLegalName);
            }

        });

        return dataItems;

    }

}